import { apiCall } from './generated/gqlClient';

const getCurrentUserApiRequest = async () => {
  const query = `
    query getCurrentUser {
      getCurrentUser {
        id
        resourceId
        ownerId
        name
        firstname
        lastname
        fullname
        gender
        birthday
        address
        city
        postcode
        country
        tags
        url
        facebook
        phone
        email
        role
        code
        codeExpiration
        active
        image
        userLanguage
        codiceFiscale
        piva
        sdi
        agreements {
          type
          decision
        }
      }
    }
  `;

  return apiCall({ query });
};

export { getCurrentUserApiRequest };
